define( 'auth-media-gateway/subclasses/Utils',['require','exports','module'],function( require, exports, module ) {	
	exports.log = function( msg ){
		if (typeof console != "undefined") console.log(msg);
	}
});
